import { useCallback } from 'react';
import { useBsoiPost } from 'scbk-services';

/**
 * nfilter public key 요청 hook
 * @returns
 */
export const useGetPublicKey = () => {
  const mutation = useBsoiPost<{}, { publicKey: string }>({
    endpoint: '/nfilter/getPublicKey',
  });

  const publicKey = useCallback(async () => {
    const res = await mutation.mutateAsync({ skipLoading: true });
    return res.publicKey;
  }, [mutation.mutateAsync]);

  return { publicKey };
};
